import { PartItem } from '@cutr/constants/cutlist';
import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

import { pick } from '@/utils/misc';

import { useMaterialGroupState } from './materialsGroup';
import { useCutlistState } from './store';

const PART_FIELDS_TO_COPY = [
  'aiMeta',
  'aiSuggestions',
  'beamRounded',
  'cncSeconds',
  'createLabel',
  'edgeProfile',
  'edgebanding',
  'roundedEdgeband',
  'grainDirection',
  'grooves',
  'label',
  'lengthMM',
  'widthMM',
  'quantity',
  'thickness',
  'partType',
];

export const DEFAULT_STORE = {
  parts: [],
};

type PartsClipboardState = {
  parts: PartItem[];
};

type PartsClipboardActions = {
  copy: (parts: PartItem[]) => void;
  cut: (parts: PartItem[]) => void;
  paste: () => void;
};

export const usePartsClipboard = create<
  PartsClipboardState & PartsClipboardActions
>()(
  devtools(
    (set) => ({
      ...DEFAULT_STORE,
      copy: (parts: PartItem[]) => {
        set(() => {
          return { parts: [...parts] };
        });
      },
      cut: (parts: PartItem[]) => {
        set(() => {
          const store = useCutlistState.getState();

          parts.forEach((part) => {
            store.removePart(part);
          });

          return { parts };
        });
      },
      paste: () => {
        set((state) => {
          const cutlistStore = useCutlistState.getState();
          const materialGroupStore = useMaterialGroupState.getState();
          const activeGroup = materialGroupStore.groups.find(
            (group) => group.id === materialGroupStore.activeGroup
          );

          if (!activeGroup) {
            return state;
          }

          state.parts.forEach((part) => {
            let newPart = cutlistStore.addPart(
              activeGroup,
              part.partType,
              part.grainDirection
            );

            newPart = {
              ...newPart,
              ...(pick(part, PART_FIELDS_TO_COPY) as Partial<PartItem>),
              groupId: activeGroup.id,
            };

            cutlistStore.setPart(newPart);
          });

          return { parts: [] as PartItem[] };
        });
      },
    }),
    { name: 'partsClipboard' }
  )
);
